import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-green-check-list',
  templateUrl: './green-check-list.component.html',
  imports: [TranslatePipe, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GreenCheckListComponent {
  labels = input<string[]>();
  translateParams = input<any>();
}
